// extracted by mini-css-extract-plugin
export default {"left":"Admin_left__ZsHM+","select_os_wrapper":"Admin_select_os_wrapper__hXwny","label":"Admin_label__66TV1","select_os":"Admin_select_os__VMPQn"};